import xmlToJSON from "xmltojson";
import html2canvas from "html2canvas";

angular.module("documents_reports")

    .controller('DocumentsReportsEditCtrl', ['$sce','$rootScope', '$scope', '$http', '$stateParams', 'Restangular', '$state', '$translate', 'modalService','$filter','Upload', 'logService',
        function ($sce, $rootScope, $scope, $http, $stateParams, Restangular, $state, $translate, modalService, $filter, Upload, logService) {

        Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
            $scope.company_uid = results.uid;
        }, function (response) {
            $scope.errorMessage = response.message;
        });

        //cargando documents types
        Restangular.all('DocumentsTypes').getList().then(function (results) {
            $scope.documentsTypes = results;
        }, function (response) {
            $scope.errorMessage = response.message;
        });          

        $scope.fileJrxml = {};
        $scope.fileJasper = {};

        $rootScope.title = $filter('translate')('documents_reports.title');

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('documents_reports.list'), url: "documents_reports.list" },
                { title: $filter('translate')('documents_reports.button_add') }
            ];
            $scope.documents_reports = {
                created_at: new Date()
            };
        }
        else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('documents_reports.list'), url: "documents_reports.list" },
                { title: $filter('translate')('documents_reports.edit') }
            ];
            Restangular.one('Documents', $stateParams.id).get().then(function (results) {
                $scope.documents_reports = results;

                Restangular.all("reports").customGET('previewjrxml/' + $stateParams.id).then(function (report) {
                        $scope.report = report;
                        $scope.parseJRXML($scope.report);
                });

            }, function (response) {
                $scope.errorMessage = response.message;
            });
        }

        $scope.uploadFileJrxml = function ($file) {
            $scope.errorMsgJrxml = undefined;
            $scope.fileJrxml = $file;
            if ($scope.fileJrxml.name.indexOf(".jrxml") < 0) {
                $scope.errorMsgJrxml = $filter('translate')('documents_reports.fileJrxmlTypeIncorrect');
            }
        }
        $scope.uploadFileJasper = function ($file) {
            $scope.errorMsgJasper = undefined;
            $scope.fileJasper = $file;
            
            if ($scope.fileJasper.name.indexOf(".jasper") < 0) {
                $scope.errorMsgJasper = $filter('translate')('documents_reports.fileJasperTypeIncorrect');
            }
        }

        $scope.uploadToServer = function () {
            var path = "";
            if ($scope.documents_reports.is_general) {
                path = "general";
            } else {
                path = $scope.company_uid;
            }
            $scope.fileJrxml.upload = Upload.upload({
                url: (window as any).CONFIG.api_url + "Reports/uploadFile",
                data: { file: $scope.fileJrxml, name: $scope.fileJrxml.name, path: path },
            });
            $scope.fileJasper.upload = Upload.upload({
                url: (window as any).CONFIG.api_url + "Reports/uploadFile",
                data: { file: $scope.fileJasper, name: $scope.fileJasper.name, path: path },
            });
            $scope.fileJrxml.upload.then(function (response) {
                if (response.data) {
                    logService.debug(response.data, response);
                    $scope.errorMsg = response.data;
                } else {
                    $scope.documents_reports.jasper_path = undefined;
                }
            }, function (response) { //error
                $scope.errorMsg = response.data;
            });
        }

        $scope.cancel = function () {
            $state.go("documents_reports.list", { "reset": false });
        };

        $scope.save = function () {
            let path = "general";
            if (!$scope.documents_reports.is_general) {
                path = $scope.company_uid;
            }
            
            let hasUploadedFiles = false;
            let uploadFileNameError = false;
            if($scope.fileJrxml.name !== undefined && $scope.fileJasper.name !== undefined) {
                if ($scope.fileJasper.name.substring(0, $scope.fileJasper.name.length - 7) === $scope.fileJrxml.name.substring(0, $scope.fileJrxml.name.length - 6)) {
                    $scope.documents_reports.jasper_path = path +'\\'+ $scope.fileJrxml.name;
                    hasUploadedFiles = true;
                } else {
                    uploadFileNameError = true;
                    $scope.errorMsgJasper = $filter('translate')('documents_reports.filesDistinctName');
                }
            }
            
            if(!uploadFileNameError) {
                if (angular.isUndefined($stateParams.id) || $stateParams.id === "")
                    Restangular.all('Documents').post($scope.documents_reports).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('documents_reports.create_success'));
                            $state.go("documents_reports.edit");
                            if(hasUploadedFiles) {
                                $scope.uploadToServer();
                            }
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                else {
                    $scope.documents_reports.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('documents_reports.edit_success'));
                            $state.go("documents_reports.edit");
                            if(hasUploadedFiles) {
                                $scope.uploadToServer();
                            }
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }                
            }
        };

            $scope.getParameters = function (str) {
                const regex = /\$P{(.*?)}/gm;
                let m;

                const parameters = new Array();
                while ((m = regex.exec(str)) !== null) {
                    // This is necessary to avoid infinite loops with zero-width matches
                    if (m.index === regex.lastIndex) {
                        regex.lastIndex++;
                    }

                    // The result can be accessed through the `m`-variable.
                    m.forEach((match, groupIndex) => {
                        parameters.push(match);
                    });
                }
                return parameters;
            };

            $scope.getFirstParameter = function (str) {
                const parameters = $scope.getParameters(str);
                return parameters.length > 0 ? parameters[0] : null;
            };

            $scope.checkConditionalExpression = function (expression) {
                let check = expression.text.replaceAll("\$F\{", "\[\"").replaceAll("\$V\{", "\[\"").replaceAll("\$P\{", "$scope.jasperParameterValues[\"").replaceAll("\}", "\"]");
                console.log(check);
                return eval(check);
            };

            $scope.qrSampleBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAAC6CAMAAAAu0KfDAAAABlBMVEX///8AAABVwtN+AAABxklEQVR4nO3QUZKDQAwD0eT+l94DgJQeCAXOtr4oGKzneb2MMebivHHSX31mbzljkC5d+hT6tj6dIcuQ+vRMDNKlS59I5zX9ZKKQ98QgXbr0X6X3f9P5NEG6dOnSSTGnk6/SpUv/PXrHEXpHHLsa6dKlT6cfq/nuMzdIly59Cv18SMGF9Wci/Y5IvyM301N9quxEshJZAy0sXbr0x9NJWRqXWH2NnnQR0qVLn0XvUL79KqVfFmmULl36FHpC9xBoByFi+ipduvQh9D4ivUllqwvwq5EuXfpEOjoK6NsJxy6iLyxduvRZ9M4lX8mSx7rieenSpQ+hry6z/TdVrl5E/1e6dOmz6H2B/kyI6TmtmhaLy0iXLv3B9FXWauXq5NSyE+nSpT+enupTyEoESto/oKVLl/54emKREemvPqf/tWCQLl36EHpfKYWc54vxLunSpU+hr2Zbn3Dkfb+yPkG6dOnPp79xTtWErmPXIV269Fn0nQ/hTHomK5FeflK6dOmz6O9N+Lgz6/XsoKVLl/6j9PS1V/LFert06dL/A31nUM13J0iXLn0inRfz9JnbM/3ipEuXPpF+DEGInN5bpEuXPpFujDEX5A/WVTvF1c+o+gAAAABJRU5ErkJggg==";


            $scope.parseJRXML = function (report) {
                let options: any = {
                    mergeCDATA: true,	// extract cdata and merge with text nodes
                    grokAttr: true,		// convert truthy attributes to boolean, etc
                    grokText: true,		// convert truthy text/attr to boolean, etc
                    normalize: true,	// collapse multiple spaces to single space
                    xmlns: false, 		// include namespaces as attributes in output
                    namespaceKey: '', 	// tag name for namespace objects
                    textKey: 'text', 	// tag name for text nodes
                    valueKey: 'value', 	// tag name for attribute values
                    attrKey: '', 	// tag for attr groups
                    cdataKey: '',	// tag for cdata nodes (ignored if mergeCDATA is true)
                    attrsAsObject: false, 	// if false, key is used as prefix to name, set prefix to '' to merge children and attrs.
                    stripAttrPrefix: false, 	// remove namespace prefixes from attributes
                    stripElemPrefix: true, 	// for elements of same name in diff namespaces, you can enable namespaces and access the nskey property
                    childrenAsArray: true 	// force children into arrays
                };
                $scope.reportJSON = xmlToJSON.parseString(report.xml, options);
                let report0 = $scope.reportJSON.jasperReport[0];

                //preparamos estilo documento
                $scope.pageStyle = {
                    "position": "relative",
                    "margin": "auto",
                    "background-color": "white",
                    "border": "1px solid #444444",
                    "-webkit-box-shadow": "0px 2px 5px 0px rgba(0,0,0,0.75)",
                    "-moz-box-shadow": "0px 2px 5px 0px rgba(0,0,0,0.75)",
                    "box-shadow": "0px 2px 5px 0px rgba(0,0,0,0.75)",
                    "width": report0.pageWidth.value + "px",
                    "height": report0.pageHeight.value + "px",
                    "padding-left": report0.leftMargin.value + "px",
                    "padding-top": report0.topMargin.value + "px",
                    "padding-right": report0.rightMargin.value + "px",
                    "padding-bottom": report0.bottomMargin.value + "px"
                };

                const leftMargin = parseFloat(report0.leftMargin.value);
                const topMargin = parseFloat(report0.topMargin.value);

                //extraemos elementos
                $scope.elements = [];
                const bands: any[] = [];

                $scope.editableParams = [];
                $scope.jasperParameterValues = [];

                //Si tiene parametros los extraemos
                if (angular.isDefined(report0.parameter)) {
                    angular.forEach(report0.parameter, function (parameter) {
                        if (!$scope.jasperParameterValues[parameter.name.value] && parameter.defaultValueExpression) {
                            let val = parameter.defaultValueExpression[0].text;
                            if (typeof (val) === "string") {
                                val = val.replaceAll("\"", "");
                            }
                            $scope.jasperParameterValues[parameter.name.value] = val;
                        }

                        if (parameter.parameterDescription) {
                            $scope.editableParams.push({
                                name: parameter.name.value,
                                description: parameter.parameterDescription[0].text,
                                default: parameter.defaultValueExpression ? parameter.defaultValueExpression[0].text : "",
                            });
                        }
                    });
                }

                $scope.styles = [];
                $scope.styleClasses = [];
                // Generar los estilos
                if (angular.isDefined(report0.style)) {
                    $scope.styles = [];
                    angular.forEach(report0.style, function (style) {
                        $scope.styles.push(style);
                    });
                    $scope.styles.forEach(function (style) {
                        if (style.conditionalStyle) {
                            angular.forEach(style.conditionalStyle, function (conditional) {
                                if (conditional.conditionExpression && conditional.style && $scope.checkConditionalExpression(conditional.conditionExpression[0])) {
                                    if (conditional.style[0].fontName) {
                                        style.fontName.value = conditional.style[0].fontName.value;
                                    }
                                    if (conditional.style[0].fontSize) {
                                        style.fontSize.value = conditional.style[0].fontSize.value;
                                    }
                                    if (conditional.style[0].hTextAlign) {
                                        style.hTextAlign = conditional.style[0].hTextAlign;
                                    }
                                }
                            });
                        }
                        console.log(style);
                        let styleStr = ".ReportStyle-" + style.name.value + " {";
                        if (style.fontName) {
                            styleStr += "font-family: " + style.fontName.value + " !important;";
                        }
                        if (style.fontSize) {
                            styleStr += "font-size: " + style.fontSize.value + "pt !important;";
                        }
                        if (style.hTextAlign) {
                            styleStr += "text-align: " + style.hTextAlign.value + " !important;";
                        }
                        styleStr += "}";
                        $scope.styles.push(styleStr);

                        let styleClasses = GetStyleClasses(style);
                        $scope.styleClasses[style.name.value] = styleClasses;
                    });
                }

                if (angular.isDefined(report0.title)) bands.push(report0.title[0].band[0]);
                if (angular.isDefined(report0.summary)) bands.push(report0.summary[0].band[0]);
                if (angular.isDefined(report0.pageHeader)) bands.push(report0.pageHeader[0].band[0]);
                if (angular.isDefined(report0.columnHeader)) {
                    var aux = angular.copy(report0.columnHeader[0].band);

                    angular.forEach(report0.columnHeader[0].band, function (item, idx) {
                        angular.forEach(item.property, function (prop) {
                            if (prop.name.value == "diaple.show_band") {
                                if (prop.value.value == false) {
                                    var index = aux.indexOf(item);
                                    aux.splice(index, 1);
                                }
                            }
                        });
                    })
                    bands.push(aux[0]);
                }

                if (angular.isDefined(report0.detail)) {

                    var aux = angular.copy(report0.detail[0].band[0]);

                    angular.forEach(report0.detail[0].band[0], function (item) {
                        angular.forEach(item.property, function (prop) {
                            if (prop.name.value == "diaple.show_band") {
                                if (prop.value.value == false) {
                                    var index = aux.indexOf(item);
                                    aux.splice(index, 1);
                                }
                            }
                        });
                    });

                    bands.push(aux);
                    //Si tiene dos detalles para dos paginas hay que cargarlo
                    if (report0.detail[0].band.length > 1) {
                        if (angular.isDefined(report0.detail)) {

                            var aux = angular.copy(report0.detail[0].band[1]);

                            angular.forEach(report0.detail[0].band[1], function (item) {
                                angular.forEach(item.property, function (prop) {
                                    if (prop.name.value == "diaple.show_band") {
                                        if (prop.value.value == false) {
                                            var index = aux.indexOf(item);
                                            aux.splice(index, 1);
                                        }
                                    }
                                });
                            });

                            bands.push(aux);
                        }
                    }
                }

                if (angular.isDefined(report0.columnFooter)) bands.push(report0.columnFooter[0].band[0]);
                if (angular.isDefined(report0.pageFooter)) bands.push(report0.pageFooter[0].band[0]);
                if (angular.isDefined(report0.lastPageFooter)) bands.push(report0.lastPageFooter[0].band[0]);
                let heightUsed = 0;
                let cont = 0;

                angular.forEach(bands, function (band, typeIdx) {
                    logService.debug(band);

                    let existsElements = false;
                    if (typeof band != "undefined") {
                        $scope.elements.push({ band: cont + 1, elements: [] });
                        heightUsed = 0;
                        angular.forEach(band, function (type, typeIdx: string) {
                            if (typeIdx === "line") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    const style = "position: absolute;" +
                                        "background-color: #444444;" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;";
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: false,
                                        style: style,
                                    });
                                });
                            } else if (typeIdx === "rectangle") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    const style = "position: absolute;" +
                                        "background-color: " + (angular.isDefined(element.reportElement[0].backcolor) ? element.reportElement[0].backcolor.value : "transparent") + ";" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;";
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: false,
                                        style: style
                                    });
                                });
                            } else if (typeIdx === "staticText") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    let classes = " d-table-cell";
                                    if (element.reportElement[0].printWhenExpression) {
                                        if (!$scope.checkConditionalExpression(element.reportElement[0].printWhenExpression[0])) {
                                            classes = " d-none";
                                        }
                                    }
                                    if (element.reportElement[0].style) {
                                        classes += $scope.styleClasses[element.reportElement[0].style.value];
                                    }

                                    if (element.reportElement[0].positionType && element.reportElement[0].positionType.value === "Float") {
                                        classes += " position-float";
                                    }

                                    const style = "position: absolute;" +
                                        "background-color: " + (angular.isDefined(element.reportElement[0].backcolor) && angular.isDefined(element.reportElement[0].mode && element.reportElement[0].mode.value == "Opaque") ? element.reportElement[0].backcolor.value : "transparent") + ";" +
                                        (angular.isDefined(element.reportElement[0].forecolor) ? "color: " + element.reportElement[0].forecolor.value + ";" : "") +
                                        //(changeValue ? "cursor: pointer;" : "") +
                                        //"border: 1px dotted #e9e9e9;" +
                                        //"white-space: pre-line;" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;" +
                                        (Array.isArray(element.textElement[0].font) && angular.isDefined(element.textElement[0].font[0].size) ? "font-size: " + element.textElement[0].font[0].size.value + "px;" : "") +
                                        "line-height: normal;" +
                                        (angular.isDefined(element.textElement[0].rotation) ? "transform: rotate(" + (element.textElement[0].rotation.value == "UpsideDown" ? "180deg" : "") + ");" : "") +
                                        "text-align: " + element.textElement[0].textAlignment.value + ";" +
                                        "vertical-align: " + element.textElement[0].verticalAlignment.value + ";";
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: false,
                                        text: element.text[0].text,
                                        expression: "",
                                        style: style,
                                        classes: classes,
                                    });
                                });
                            } else if (typeIdx === "textField") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    let classes = " d-table-cell";
                                    if (element.reportElement[0].printWhenExpression) {
                                        if (!$scope.checkConditionalExpression(element.reportElement[0].printWhenExpression[0])) {
                                            classes = " d-none";
                                        }
                                    }
                                    if (element.reportElement[0].style) {
                                        classes += $scope.styleClasses[element.reportElement[0].style.value];
                                    }

                                    if (element.reportElement[0].positionType && element.reportElement[0].positionType.value === "Float") {
                                        classes += " position-float";
                                    }

                                    let changeValue = (typeof element.textFieldExpression != "undefined" && element.textFieldExpression[0].text != null && element.textFieldExpression[0].text.indexOf("$P") == 0);
                                    const style = "position: absolute; font-size: 12pt;" +
                                        "background-color: " + (angular.isDefined(element.reportElement[0].backcolor) && angular.isDefined(element.reportElement[0].mode && element.reportElement[0].mode.value === "Opaque") ? element.reportElement[0].backcolor.value : "transparent") + ";" +
                                        (angular.isDefined(element.reportElement[0].forecolor) ? "color: " + element.reportElement[0].forecolor.value + ";" : "") +
                                        (changeValue ? "cursor: pointer;" : "") +
                                        (changeValue ? "border: 1px dotted #444444;" : "") +
                                        //"white-space: pre-line;" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;" +
                                        (Array.isArray(element.textElement[0].font) && angular.isDefined(element.textElement[0].font[0].size) ? "font-size: " + element.textElement[0].font[0].size.value + "px;" : "") +
                                        "line-height: normal;" +
                                        (Array.isArray(element.textElement[0].font) && angular.isDefined(element.textElement[0].font[0].isBold) ? "font-weight: " + (element.textElement[0].font[0].isBold.value ? "bold" : "normal") + ";" : "") +
                                        "overflow-wrap: break-word;" +
                                        (angular.isDefined(element.textElement[0].textAlignment) ? "text-align: " + element.textElement[0].textAlignment.value + ";" : "") +
                                        (angular.isDefined(element.textElement[0].rotation) ? "transform: rotate(" + (element.textElement[0].rotation.value == "UpsideDown" ? "180deg" : "") + ");" : "") +
                                        (angular.isDefined(element.textElement[0].verticalAlignment) ? "vertical-align: " + element.textElement[0].verticalAlignment.value + ";" : "");
                                    let text = "";
                                    let name = element.textFieldExpression[0].text;
                                    //busca propieda de valor por defecto
                                    if (angular.isDefined(element.reportElement[0].property)) {
                                        angular.forEach(element.reportElement[0].property, function (property) {
                                            if (property.name.value === "diaple.default_value") text = property.value.value;
                                            if (property.name.value === "diaple.parameter_name") {
                                                name = property.value.value;
                                                changeValue = true;
                                            }
                                        });
                                    }
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: changeValue,
                                        text: $sce.trustAsHtml(text),
                                        expression: name,
                                        style: style,
                                        classes: classes,
                                    });
                                });
                            } else if (typeIdx === "image") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    let classes = " d-table-cell";
                                    if (element.reportElement[0].printWhenExpression) {
                                        if (!$scope.checkConditionalExpression(element.reportElement[0].printWhenExpression[0])) {
                                            classes = " d-none";
                                        }
                                    }

                                    if (element.reportElement[0].positionType && element.reportElement[0].positionType.value === "Float") {
                                        classes += " position-float";
                                    }

                                    //extraemos parametros, si hay varios cogemos solo primero
                                    let parameterExpression = null;
                                    if (angular.isDefined(element.imageExpression)) {
                                        parameterExpression = $scope.getFirstParameter(element.imageExpression[0].text);
                                    }

                                    let backgroundSize = angular.isDefined(element.scaleImage) ? element.scaleImage.value : "cover";
                                    if (backgroundSize == "RetainShape") backgroundSize = "contain";
                                    if (backgroundSize == "FillFrame") backgroundSize = "cover";
                                    const changeValue = (typeof element.imageExpression != "undefined" && element.imageExpression[0].text != null && element.imageExpression[0].text.indexOf("$P{P_IMAGE") >= 0);
                                    const style = "position: absolute;" +
                                        "background-color: " + (angular.isDefined(element.reportElement[0].backcolor) && angular.isDefined(element.reportElement[0].mode && element.reportElement[0].mode.value == "Opaque") ? element.reportElement[0].backcolor.value : "transparent") + ";" +
                                        (changeValue ? "cursor: pointer;" : "") +
                                        "border: 1px dotted #444444;" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;" +
                                        (angular.isDefined(element.hAlign) ? "text-align: " + element.hAlign.value + ";" : "") +
                                        (angular.isDefined(element.vAlign) ? "vertical-align: " + element.vAlign.value + ";" : "") +
                                        (angular.isDefined(element.imageExpression) && element.imageExpression[0].text.indexOf("?rotate") > 0 ? "transform: rotate(180deg);" : "") +
                                        "background-repeat: no-repeat;" +
                                        "background-position: center center;" +
                                        "background-image: url('/assets/img/no-image.png') !important;" +
                                        "background-size: " + backgroundSize + ";";
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: changeValue,
                                        text: "", //element.imageExpression[0].text,
                                        expression: parameterExpression, //element.imageExpression[0].text,
                                        style: style,
                                        size_info: element.reportElement[0].width.value + "x" + element.reportElement[0].height.value,
                                        classes: classes,
                                    });
                                });
                            } else if (typeIdx === "componentElement") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    console.log(element);


                                    if (angular.isDefined(element.QRCode)) {
                                        let classes = " d-table-cell";
                                        if (element.reportElement[0].printWhenExpression) {
                                            if (!$scope.checkConditionalExpression(element.reportElement[0].printWhenExpression[0])) {
                                                classes = " d-none";
                                            }
                                        }

                                        if (element.reportElement[0].positionType && element.reportElement[0].positionType.value === "Float") {
                                            classes += " position-float";
                                        }

                                        //es un QR, ponemos ejemplo
                                        logService.debug(element);
                                        const style = "position: absolute;" +
                                            "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                            "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                            "width: " + element.reportElement[0].width.value + "px;" +
                                            "height: " + element.reportElement[0].height.value + "px;" +
                                            (angular.isDefined(element.hAlign) ? "text-align: " + element.hAlign.value + ";" : "") +
                                            (angular.isDefined(element.vAlign) ? "vertical-align: " + element.vAlign.value + ";" : "") +
                                            (angular.isDefined(element.imageExpression) && element.imageExpression[0].text.indexOf("?rotate") > 0 ? "transform: rotate(180deg);" : "") +
                                            "background-repeat: no-repeat;" +
                                            "background-position: center center;" +
                                            "background-image: url(" + $scope.qrSampleBase64 + ");" +
                                            "background-size: contain;";
                                        $scope.elements[cont].elements.push({
                                            type: typeIdx,
                                            uuid: element.reportElement[0].uuid.value,
                                            changeValue: false,
                                            text: "",
                                            expression: "",
                                            style: style,
                                            classes: classes,
                                        });
                                    }
                                });
                            }
                        });
                        if (!existsElements) {
                            $scope.elements.splice(cont, 1);
                            cont--;
                        }
                        heightUsed += band.height.value;
                        cont++;
                    }
                    existsElements = false;
                });
                logService.debug($scope.elements);
                //evaluate expression
                $scope.parameters = [];
                angular.forEach($scope.elements, function (band) {
                    angular.forEach(band.elements, function (element) {
                        if (element.changeValue) {
                            $scope.parameters.push({
                                name: element.expression,
                                value: ""
                            });
                        }
                    });
                });

                setTimeout(function () {
                    //hacemos captura para generar thumbnail de tipo de documento si no tiene ya
                    //html2canvas se ha actualizado a una nueva version, onrendered ha dejado de funcionar en la nueva

                    if (!report.has_thumbnail) {
                        /*html2canvas($("#jrxml-preview .page")[0], {
                            onrendered: function (canvas) {
                                var data = {
                                    document_id: $scope.doc_report.id,
                                    base64: canvas.toDataURL()
                                };
                                Restangular.all("documents").customPOST(data, 'thumbnail').then(function (result) {
                                    logService.debug(result);
                                });
                            }
                        });*/
                        $("#jrxml-preview .page").css("box-shadow", "");
                        html2canvas($("#jrxml-preview .page")[0], { scrollX: 0, scrollY: 0 }).then(canvas => {
                            const image = canvas.toDataURL("image/png", 1.0);
                            const data = {
                                document_id: $scope.document.id,
                                base64: image
                            };
                            Restangular.all("documents").customPOST(data, 'thumbnail').then(function (result) {
                                logService.debug(result);
                            });
                        });
                    }


                    let bands: HTMLElement[] = [];

                    angular.element(".band-element").each(function (index, element) {
                        bands.push(element);
                    });
                    bands.sort((a, b) => {
                        const aTop = parseFloat(a.style.top);
                        const bTop = parseFloat(b.style.top);
                        return aTop - bTop;
                    });

                    let heightIncr = 0;
                    bands.forEach(band => {
                        // If band has class d-none, skip it
                        if (!band.classList.contains("d-none")) {
                            console.log(band);
                            let heightDiff = band.scrollHeight - parseInt(band.style.height.replace("px", ""));
                            if (heightDiff < 0) heightDiff = 0;
                            heightIncr += heightDiff;

                            if (heightDiff > 0) {
                                band.style.height = (parseInt(band.style.height.replace("px", "")) + heightDiff) + "px";
                            }

                            console.log("Height incr for band: " + heightIncr);
                            if (band.classList.contains("position-float")) {
                                console.log("Adjusting position for float band");
                                band.style.top = (parseInt(band.style.top.replace("px", "")) + heightIncr) + "px";
                            }
                        }
                    });


                }, 1000);

                angular.forEach($scope.documentConfig, function (parameter) {
                    angular.forEach($scope.parameters, function (scopeParameter) {
                        if (scopeParameter.name == parameter.name) {
                            //scopeParameter.value = parameter.value;
                            angular.forEach($scope.elements, function (e) {
                                angular.forEach(e.elements, function (element) {
                                    if (element.expression == parameter.name) {
                                        element.values = parameter.values;
                                        angular.forEach(parameter.values, function (param) {
                                            if (param.language_id == $rootScope.languageId) {
                                                if (element.type == "image") {
                                                    if (param.value != "") element.image_style = "background-image: url('" + param.value + "') !important;"; // background-size: contain !important;";
                                                } else {
                                                    element.text = $sce.trustAsHtml(param.value);
                                                }
                                            }
                                        });
                                    }
                                });
                            });
                        }
                    });
                });

            }

            function GetStyleClasses(style) {
                let className = " ReportStyle-" + style.name.value;;
                return className + " " + GetStyleClassesRec(style);
            }

            function GetStyleClassesRec(style) {
                if (style.style) {
                    let parentStyle = $scope.styles.find(function (s) {
                        return s.name.value == style.style.value;
                    });
                    if (parentStyle) {
                        let className = "ReportStyle-" + parentStyle.name.value;;
                        return className + " " + GetStyleClassesRec(parentStyle);
                    }
                }
                return "";
            }


    }]);